export class Configuration {
    IS_DEBUG: boolean;
    URLQUATTROAUTOSAES: string;
    URLDATATRANSFER: string;
    URLQUATTROAUTOSWS: string;
    URLQUATTROAUTO: string;
    URLQUATTRODIVERSOS: string = "";
    public URL_SHORTENER_AES: string;
    MULTINEGOCIO_ID: number;
    SNACK_BARTIME: number;
    S4_KEY: string;
    QUATTRO_OAUTH_SERVICE_URL: string;
    API_B2C: string;
    API_CLIENTE: string;
    API_POLIZA: string;
    API_CATALOGO: string="";
    QUATTRO_PEEM:string="";
    PROJECT_KEY: string;
    UNIQUE_URL: string;
    URLPOLIZAS: string;
    URLPOLIZALAZY: string;
    URLIMPRESIONES: string;
    COPSIS_API: string;
    SURA_API: string="";
    API_ESTRUCTURA:string="";
    public PLATFORM: boolean = false;
    public URLPLATFORM: string = '';
    URLQUATTROASEGURADORAS:string='';
    URLQUATTROSECURE:string;
    public ciasComputeWS = [7, 14, 18, 20, 22, 31, 33, 44, 49, 88];
    public ciasSpring = [35];
    public ciasConTipoUnidad = [1, 18, 20, 22, 29];
    public ciasPrintSrping = [1, 14, 20, 29, 31, 35, 49];
    public validatorVin = [1, 14, 22, 31];
    public dataCoberturas = [];

    constructor() {

        this.PLATFORM = this.getPlatform();
        this.URLPLATFORM = this.getUrlPlatform();
        this.IS_DEBUG = false;
        this.MULTINEGOCIO_ID = 154;//61 es para producccion y 67 es la copia para QA
        this.URLQUATTROAUTOSAES = 'https://quattro-autos-ws-aes-dot-quattrocrm-201805.appspot.com/';
        this.URLQUATTROAUTO = 'https://quattro-auto-aes-dot-sio4-168120.uc.r.appspot.com/';
        this.URLQUATTROAUTOSWS = 'https://lb3.copsis.com/quattro-autos-ws/'; /* cambiar */
        this.URLDATATRANSFER = 'https://lb3.copsis.com/data-transfer-api/'; /* cambiar */
        //this.URL_SHORTENER_AES = "https://quattro-shortener-aes-dot-quattrocrm-201805.appspot.com/";
        this.URL_SHORTENER_AES = "https://api.quattrocrm.mx/sioquatro/publics/";
        this.SNACK_BARTIME = 4000;
        this.S4_KEY = 'uLmdvb2dsZS5jb20vY2hhdC1kYXRhYmFzZS05NTdjMSIsIm5hbWUiOiJIZWJlc';
        this.API_B2C = 'http://localhost:8080/';
        this.API_CLIENTE = 'http://localhost:8080/';
        this.API_POLIZA = 'http://localhost:8080/';
        this.PROJECT_KEY = 'd';
        this.UNIQUE_URL = 'https://api.quattrocrm.mx/';
        this.URLPOLIZALAZY = "https://skynet.copsis.com:8181/sio4apolizas-lazy-fetch/";
        this.URLPOLIZAS = "https://skynet.copsis.com:8181/sio4apolizas-new/";
        this.URLIMPRESIONES = 'https://lb4.copsis.com/sio4aimpresiones/';
        this.URLQUATTROSECURE = 'https://quattro-secure-d4f4hpx6ga-uc.a.run.app/';
        this.COPSIS_API = "https://api.copsis.com/";

        switch (window.location.hostname) {
            case 'localhost':
                this.QUATTRO_OAUTH_SERVICE_URL = 'http://localhost:8081/';
                this.QUATTRO_OAUTH_SERVICE_URL = this.UNIQUE_URL;
                this.URLQUATTROAUTOSWS = 'https://lb3.copsis.com/quattro-autos-ws/';
                this.API_B2C = 'http://localhost:8080/';
                this.API_CLIENTE = 'http://localhost:8081/';
                this.URLQUATTROAUTO = 'http://localhost:8080/auto/';
                this.URLQUATTRODIVERSOS = 'http://localhost:8080/diversos/';
                //this.API_B2C='https://quattro-b2c-aes-dot-sio4-168120.appspot.com/';
                //this.API_CLIENTE='https://quattro-cliente-aes-dot-sio4-168120.uc.r.appspot.com/';
                //this.URLQUATTROAUTOAES = 'https://quattro-auto-aes-dot-sio4-168120.uc.r.appspot.com/'; 
                this.URLQUATTROASEGURADORAS = 'https://lb4.copsis.com/quattro-aseguradoras/';
                this.API_CATALOGO = this.UNIQUE_URL;
                this.API_ESTRUCTURA = this.UNIQUE_URL;
                this.QUATTRO_PEEM = this.UNIQUE_URL;
                this.SURA_API = this.UNIQUE_URL;
                break;
            case "quattrob2c-qa.web.app":
                // skynet
                this.QUATTRO_OAUTH_SERVICE_URL = this.UNIQUE_URL;
                this.API_B2C = this.UNIQUE_URL;
                this.API_CLIENTE = this.UNIQUE_URL;
                this.URLQUATTROAUTO = this.UNIQUE_URL + 'autos/';
                this.URLQUATTRODIVERSOS = this.UNIQUE_URL + 'diversos/';
                this.API_POLIZA = this.UNIQUE_URL;
                this.URLPOLIZAS = 'https://lb4.copsis.com/sio4apolizas-new/';
                this.URLPOLIZALAZY = 'https://lb4.copsis.com/sio4apolizas-lazy-fetch/';
                this.URLIMPRESIONES = 'https://lb4.copsis.com/sio4aimpresiones/';
                this.API_CATALOGO = this.UNIQUE_URL;
                this.API_ESTRUCTURA = this.UNIQUE_URL;
                this.QUATTRO_PEEM = this.UNIQUE_URL;
                break;
            case "nacoseguro.com":
                // prod
                this.QUATTRO_OAUTH_SERVICE_URL = this.UNIQUE_URL;
                this.API_B2C = this.UNIQUE_URL;
                this.API_CLIENTE = this.UNIQUE_URL;
                this.URLQUATTROAUTO = this.UNIQUE_URL + 'autos/';
                this.URLQUATTRODIVERSOS = this.UNIQUE_URL + 'diversos/';
                this.API_POLIZA = this.UNIQUE_URL;
                this.URLPOLIZAS = 'https://lb4.copsis.com/sio4apolizas-new/';
                this.URLPOLIZALAZY = 'https://lb4.copsis.com/sio4apolizas-lazy-fetch/';
                this.URLIMPRESIONES = 'https://lb4.copsis.com/sio4aimpresiones/';
                this.URLQUATTROASEGURADORAS = this.UNIQUE_URL;
                this.API_CATALOGO = this.UNIQUE_URL;
                this.API_ESTRUCTURA = this.UNIQUE_URL;
                this.QUATTRO_PEEM = this.UNIQUE_URL;
                this.SURA_API = this.UNIQUE_URL;
                break;
            default:
                this.QUATTRO_OAUTH_SERVICE_URL = this.UNIQUE_URL;
                this.API_B2C = this.UNIQUE_URL;
                this.API_CLIENTE = this.UNIQUE_URL;
                this.URLQUATTROAUTO = this.UNIQUE_URL + 'autos/';
                this.URLQUATTRODIVERSOS = this.UNIQUE_URL + 'diversos/';
                this.API_POLIZA = this.UNIQUE_URL;
                this.URLPOLIZAS = 'https://lb4.copsis.com/sio4apolizas-new/';
                this.URLPOLIZALAZY = 'https://lb4.copsis.com/sio4apolizas-lazy-fetch/';
                this.URLIMPRESIONES = 'https://lb4.copsis.com/sio4aimpresiones/';
                this.URLQUATTROASEGURADORAS = this.UNIQUE_URL;
                this.API_CATALOGO = this.UNIQUE_URL;
                this.API_ESTRUCTURA = this.UNIQUE_URL;
                this.QUATTRO_PEEM = this.UNIQUE_URL;
                this.SURA_API = this.UNIQUE_URL;
                break;
        }
    }

    getDominio():string{
        let dominio = window.location.hostname;
        if(window.location.hostname == "localhost"){
            // dominio = "nacoseguro.com";
            dominio = "micuenta.quattrocrm.mx";
        }
        return dominio;
    }

    getPlatform(): boolean {
        if (navigator.platform.toLowerCase().includes('iphone') && navigator.userAgent.toLowerCase().includes('iphone') && navigator.appVersion.toLowerCase().includes('iphone')) {
            return true;
        } else {
            return false;
        }
    }

    getUrlPlatform(): string {
        if (window.location.hostname == 'localhost') {
            return 'http://' + window.location.hostname + ':' + window.location.port + '/';
        } else {
            return 'https://' + window.location.hostname + '/';
        }
    }

    getURLAutosWS(cia: number): string {
        let _url: string;
        if (this.ciasComputeWS.filter((i) => i === cia)[0]) {
            _url = this.URLQUATTROAUTOSWS;
        } else if (this.ciasSpring.filter((i) => i === cia)[0]) {
            _url = this.URLQUATTROAUTO;
        } else {
            _url = this.URLQUATTROAUTOSAES;
        }
        return _url;
    }

    getCiaConTipoUnidad(cia: number): boolean {
        return this.ciasConTipoUnidad.filter((i) => i === cia)[0] ? true : false;
    }

    isCiaPrintSpring(cia: number): boolean {
        return this.ciasPrintSrping.filter((i) => i === cia)[0] ? true : false;
    }

    isMobile(): boolean {
        console.log(navigator.userAgent);
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)) {
            return true;
        }
        return false;
    }
}

export class Encrypted {
    ZERO: string;
    UNO: string;
    DOS: string;
    TRES: string;
    CUATRO: string;
    CINCO: string;
    SEIS: string;
    SIETE: string;
    OCHO: string;
    NUEVE: string;
    DIEZ: string;
    ONCE: string;
    DOCE: string;
    TRECE: string;
    CATORCE: string;
    QUINCE: string;
    DIESICEIS: string;
    DIESICIETE: string;
    DIESIOCHO: string;
    DIESINUEVE: string;
    VEINTE: string;
    VEITIUNO: string;
    VEITIDOS: string;
    VEINTITRES: string;
    VEINTICUATRO: string;
    VEINTICINCO: string;
    VEINTISEIS: string;
    VEINTISIETE: string;
    VEINTIOCHO: string;
    VEINTINUEVE: string;
    TREINTA: string;
    TREINTAYUNO: string;
    TREINTAYTRES: string;
    TREINTAYCUATRO: string;
    CUARENTAYNUEVE: string;
    SETENTAYUNO: string;

    constructor() {
        this.ZERO = "l66xHtlkmi56Uqz3MEYuqw==";
        this.UNO = "94c3qaBTlOBbdUWPBkxEmg==";
        this.DOS = "f917Va5WwTC+2N4o3l4+BA==";
        this.TRES = "Iq11nyEuKhO2atPO7zevuw==";
        this.CUATRO = "EqCZqGFttusLNojjyxsIBQ==";
        this.CINCO = "DkxlYDgr8ppqraux+geoWQ==";
        this.SEIS = "NrJZ2eu8864dVTrtvx+UWQ==";
        this.SIETE = "yvzHgyDWbKBDnl9x3vHpyw==";
        this.OCHO = "HPprvkjaW3dEDhHb4rMbUw==";
        this.NUEVE = "G3qKOv/JCLtcizqrY/DUUg==";
        this.DIEZ = "BZkFTQl+/ypfyS8ecK8cDQ==";
        this.ONCE = "BHj2Q7IqI3UAMAvoFTMpHg==";
        this.DOCE = "PYYCJxaUzGWcuzoy4aVrEw==";
        this.TRECE = "q5pNsocdNEy34aRW1AXEkQ==";
        this.CATORCE = "NOwi9GtnliNcum4Bsam09Q==";
        this.QUINCE = "8CgddnXyqkVSMum/oKjifg==";
        this.DIESICEIS = "YcOJ/i++O0aZ37B7J8KRGg==";
        this.DIESICIETE = "H/QTfZ6fL66wuho1zdnzSg==";
        this.DIESIOCHO = "/k9PiRJ01NnBnN4pcfPzQQ==";
        this.DIESINUEVE = "UbOxuPNiFuGGuLxKgMMFPg==";
        this.VEINTE = "vr0Iqzix9uaS9cyiQF490w==";
        this.VEITIUNO = "s6AlIo/7ITm5aqHXfmJDBQ==";
        this.VEITIDOS = "qS0T0zyrYPon/Z9j6k56pA==";
        this.VEINTITRES = "JgcYdqdOA1LYdEZxZo6BJg==";
        this.VEINTICUATRO = "2iLVMs9V62MzItYn3gpj+Q==";
        this.VEINTICINCO = "4ZtLpd2BqE6sLPcllqYI5Q==";
        this.VEINTISEIS = "4MWOMT3P8OX+xwHJe1VusA==";
        this.VEINTISIETE = "aWaY1nKdEWDXzHVgm3jbTw==";
        this.VEINTIOCHO = "YLIMtcwCUjJ6pVv3rW2+Dw==";
        this.VEINTINUEVE = "nZmCFHLBLCdgpzGYE8muHg==";
        this.TREINTA = "ITHx8Tgrcck395BMh9xaCw==";
        this.TREINTAYUNO = "tR8z7IRsRYkb9Nz2eOkuuQ==";
        this.TREINTAYTRES = "N/6EdiG+9FGhKBKG9xi+cA==";
        this.TREINTAYCUATRO = "//Ezav7KBIrvxm6GbdEnZA==";
        this.CUARENTAYNUEVE = "62Jfo3wHgxkp6/jfIa9oCg==";
        this.SETENTAYUNO = "KLwPDUpeeBystYhHI/1/Dg==";
    }
}